export default __webpack_public_path__ + "static/media/placeholder_portfolio02-it-web.a879afcd.png";